// extracted by mini-css-extract-plugin
export default {"main":"Ficha_main__wFXps","content":"Ficha_content__kz+y6","accordion":"Ficha_accordion__ibvSf"};